module.exports = __webpack_public_path__ + "img/no-receiver.d61cb682.png";